module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Additional info","customFields":{"loadError":"Something went wrong and we couldn\u0027t load this contact\u0027s custom fields. Please try again."}}}')
  delete Component.options._Ctor
}
